var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',_vm._l((_vm.form),function(item){return _c('div',{key:item.uid},[_c('public-form-item',{attrs:{"itemData":item,"answers":_vm.completedForm}}),_c('div',{staticClass:"clearfix"})],1)}),0)}
var staticRenderFns = []

export { render, staticRenderFns }